module.exports = __webpack_public_path__ + "static/media/n_icon_header_bg.e43fd4ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_header_bg.png
// module id = 1804
// module chunks = 0 1